import { Container, Grid } from '@mui/material'
import moment from 'moment'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { showEvent, toggleFormEvent } from '../../../../../redux/actions/events'
import { IRootState } from '../../../../../redux/types'
import CustomSnackBar from '../../../../shared/components/CustomSnackBar'
import DetailHeroPanel from '../../../../shared/components/DetailHeroPanel'
import DetailInfoPanel from '../../../../shared/components/DetailInfoPanel'
import ScreenLoading from '../../../../shared/components/ScreenLoading'
import ButtonBack from '../../../../shared/components/buttons/ButtonBack'
import ShareIcon from '../../../../shared/components/icons/ShareIcon'
import VerifyAccessRoute from '../../../../shared/components/routes/VerifyAccessRoute'
import useGeneralSummaryReport from '../../../../shared/hooks/useGeneralSummaryReport'
import useUserDisplaytime from '../../../../shared/hooks/useUserDisplaytime'
import { MoreInfoDetail } from '../../../library/models/resource'
import AdminDetailInfo from '../../../library/ui/components/AdminDetailInfo'
import EventTemplate from '../components/EventTemplate'
import EventsModal from '../components/EventsModal'

function EventDetail() {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()
  const { id } = useParams<{ id: string }>()
  const location = useLocation()

  const { event_selected, showForm, error, msg, loading } = useSelector((state: IRootState) => state.event)

  // Send track of user
  useUserDisplaytime({ foreign: event_selected })
  const { handleViewGeneralSummaryReport } = useGeneralSummaryReport(4)

  // Ready Page
  useEffect(() => {
    handleViewGeneralSummaryReport(Number(id))
    dispatch(showEvent(id))
  }, [id])

  let infoDetail: MoreInfoDetail = {
    item: [
      {
        id: 1,
        type: 'date',
        title: `${t('start-date')}`,
        color: 'grey6',
        info: `${moment(event_selected?.date_ini).format('LLL')}`
      },
      {
        id: 2,
        type: 'date',
        title: `${t('end-date')}`,
        color: 'grey6',
        info: `${moment(event_selected?.date_end).format('LLL')}`
      }
    ]
  }

  return (
    <>
      {event_selected != null && (
        <Container id="event-container" maxWidth="lg">
          {showForm && <EventsModal />}

          <ButtonBack />

          <Grid container spacing={5}>
            <Grid item xs={12} md={8} id="event-cover">
              <VerifyAccessRoute visibility={event_selected.visibility} />
              {location.pathname.includes('admin') && <AdminDetailInfo resourceSelected={event_selected} />}
              <EventTemplate event={event_selected} />
            </Grid>

            <Grid data-testid="detail-hero-panel" item xs={12} md={4}>
              <DetailHeroPanel
                visibility={event_selected.visibility}
                status={event_selected.status}
                brand={event_selected.brand_id}
                title={event_selected.title}
                author={event_selected.created_by}
                description={event_selected.description}
                edit={() => {
                  dispatch(toggleFormEvent())
                }}
                event={event_selected.link}
                eventText={event_selected.text_button != null ? event_selected.text_button : t('admin.events.join-here')}
                share={
                  <ShareIcon
                    link={`${window.location.href}`}
                    visibility={event_selected.visibility}
                    description={event_selected.description}
                    multimedia={event_selected.image}
                    title={event_selected.title}
                    type="event"
                    component="buttonTextGreen"
                    buttonTextGreen={t('share')}
                  />
                }
              />
              <DetailInfoPanel attributes={infoDetail} />
            </Grid>
          </Grid>
        </Container>
      )}

      <CustomSnackBar errors={[error]} msgs={[msg]} />
      <ScreenLoading loadings={[loading]} />
    </>
  )
}

export default EventDetail
